module.exports = __webpack_public_path__ + "static/media/badge_level_4_2.aa88a84a.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_4_2.png
// module id = 503
// module chunks = 0